import ListItems from "./ListItem";
import React from "react";
import { ListGroup } from "reactstrap";

interface propsTypes {
  children?: React.ReactNode;
  listItem?: string[];
  className?: string;
  id?: string;
}

const UL = (props: propsTypes) => {
  const { children } = props;
  return <ListGroup {...props}>{props.listItem ? props.listItem.map((item, i) => <ListItems val={item} key={i} children />) : children}</ListGroup>;
};

export default UL;
